/**
 * Central object used for managing global renderer options
 */
export const OptionsManager = Object.freeze({
    DEBUG_COLOR_IMAGERY_TILES_BY_ZOOM_LEVEL: false,
    DEBUG_COLOR_IMAGERY_TILES_RANDOMLY: false,
    DEBUG_KML_NAN_ASSERT: true,
    KML_HEIGHT_OFFSET: 0,
    KML_TEXT_HEIGHT_OFFSET: 0,
    POINT_CLOUD_TILE_WEIGHT: 1,
    BATCH_MODEL_TILE_WEIGHT: 4,
    INSTANCED_MODEL_TILE_WEIGHT: 4,
    GLTF_MODEL_TILE_WEIGHT: 4,
});
